export const DocumentsListContents = {
  labels: {
    docType: "Uploaded Document",
    subDocType: "Document Type",
    uploadedBy: "Uploaded By",
    updatedOn: "Updated On",
    documentURL: "Action"
  },
  DocumentType: {
    POI: "Proof of Identity",
    POB: "Proof of Buisness",
    POA: "Proof of Address"
  }
};

export const DocumentHeader = "Documents Repository";
